const provisionalRemedyAnswerStatus = {
  Nuevo: 1,
  Aprobado: 2,
  Objetado: 3,
  Cancelado: 4,
};

export default provisionalRemedyAnswerStatus;
